export default "__VITE_ASSET__141c9a10__"